<template>
  <el-dialog
    v-if="selectedEvent"
    id="calendarModal"
    :visible.sync="showModal"
    :width="dialogWidth"
    top="35vh"
  >
    <div
      class="leader"
      @click="$router.push({
        name: 'myLeaderDetail',
        params: {id: selectedEvent.extendedProps.leaderUuid}
      }).catch((err) => {})"
    >
      {{ selectedEvent.title }}
    </div>

    <div class="dateTime">
      {{ selectedEvent.start | moment('HH:mm') }} - {{ selectedEvent.end | moment('HH:mm') }}
    </div>

    <div
      v-if="selectedEvent.extendedProps.session"
      class="session"
    >
      {{ selectedEvent.extendedProps.session }}
    </div>

    <div class="actions">
      <el-link
        icon="el-icon-date"
        :href="googleCalendarLink"
        target="_blank"
      >
        {{ $t('coach.myCalendar.addToGoogle') }}
      </el-link>
    </div>
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  mixins: [dialog],

  props: {
    selectedEvent: {
      type: Object,
      default: null,
    },
  },

  computed: {
    showModal: {
      // getter
      get() {
        return !!this.selectedEvent;
      },
      // setter
      set(visible) {
        if (!visible) {
          this.$emit('update:selectedEvent', null);
        }
      },
    },

    googleCalendarLink() {
      // http://www.google.com/calendar/event?action=TEMPLATE&trp=false&text=VueConf&location=WROC%C5%81AW,%20POLAND&details=The%20first%20Official%20Vue.js%20Conference%20in%20the%20world!&dates=20191108T020934Z/20191109T020934Z
      const start = this.$moment(this.selectedEvent.start).format('YYYYMMDDTHHmmss');
      const end = this.$moment(this.selectedEvent.end).format('YYYYMMDDTHHmmss');
      let details;
      if (this.selectedEvent.extendedProps.session !== 'on_boarding') {
        details = `${this.selectedEvent.extendedProps.session} meeting with ${this.selectedEvent.title}`;
      } else {
        details = `Introductory meeting with ${this.selectedEvent.title}`;
      }

      let link = 'http://www.google.com/calendar/event?action=TEMPLATE&trp=false';
      link += `&text=Meeting with ${this.selectedEvent.title}`;
      link += `&details=${details}`;
      link += `&dates=${start}/${end}`;
      return link;
    },
  },
};
</script>

<style lang="scss">
#calendarModal {
  .el-dialog__header {
    padding-top: 0;
    padding-bottom: 0;
  }

  .el-dialog__body {
    & > div {
      margin-bottom: 10px;
      font-size: 16px;
    }

    .leader {
      font-weight: bold;
      font-size: 16px;
      cursor: pointer;
      margin-bottom: 12px;
    }
  }
}
</style>
